module.exports = __webpack_public_path__ + "img/image49.124f2bef.png";